import { render, staticRenderFns } from "./mdl-landing.vue?vue&type=template&id=2ec9a13a&"
import script from "./mdl-landing.vue?vue&type=script&lang=js&"
export * from "./mdl-landing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports